import classNames from 'classnames';

import ButtonCircle from '@/components/ButtonCircle';

export interface BlockLinkProps {
  linkText?: string;
  linkExternal?: string;
  linkInternal?: string;
  buttonStyle?: string;
  extraClasses?: string;
  arrowFill?: string;
}

const BlockLink: React.FC<BlockLinkProps> = ({
  linkText,
  linkExternal,
  linkInternal,
  buttonStyle,
  extraClasses,
  arrowFill,
}) => {
  if (!linkExternal && !linkInternal) {
    console.warn('BlockLink: No link provided');
    return;
  }

  return (
    <>
      {(linkExternal || linkInternal) && (
        <a
          className={classNames(
            'button',
            { 'button--external': linkExternal },
            buttonStyle ? `button--${buttonStyle}` : 'button--primary',
            extraClasses
          )}
          href={linkExternal || linkInternal}
          target={linkExternal ? '_blank' : '_self'}
          rel="noreferrer"
        >
          {linkText && linkText}
          <ButtonCircle
            arrowFill={arrowFill}
            arrowHeight={13}
            arrowWidth={17}
          />
        </a>
      )}
    </>
  );
};

export default BlockLink;
